module.exports = __webpack_public_path__ + "img/hu.8bfc4b2.svg";